function canShowLabel(size) {
    if (size !== "small") {
        return true;
    }
    return false;
}

export { canShowLabel };
